@use '@/scss/underscore' as _;

.nav {
  border-bottom: 1px solid var(--color-surface-5);
  display: flex;
  margin-top: _.unit(1);
}
